import {Instance} from 'mobx-state-tree';

import {DoTestDiagramLabelCompletionQuestion} from './do-test-diagram-label-completion.store';

export const DoTestFlowChartComplexQuestion = DoTestDiagramLabelCompletionQuestion.named(
  'DoTestFlowChartComplex'
).views((self) => ({
  get groupName() {
    return 'Flowchart Complex';
  },
}));

export interface DoTestFlowChartComplexQuestionInstance
  extends Instance<typeof DoTestFlowChartComplexQuestion> {}
